import axios from "axios";
import { httpPost } from "../../../../../../../Utils/apis/apis";

export const submitPaymentDetails = async (isEditMode, payload) => {
  const latestData = {
    spName: isEditMode ? "DF.usp_EditPaymentDetails" : "DF.usp_AddPaymentDetails",
    parameters: { parametersAsJsonString: JSON.stringify(payload) },
  };
  return httpPost(`/SQLBasedForm/SQLFormOperations`, latestData, "", true);
};

export const lookupBankBySortCode = async (sortCode, bankFinderUrl) => {
  try {
    const response = await axios.post(bankFinderUrl, { sortCode });
    return response?.data;
  } catch (error) {
    return {
      found: false,
      error: error?.message || "Failed to look up bank details for this sort code",
    };
  }
};
